.feedback-page {
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: center;
    overflow: auto;
    padding: 100px 0;
    border-top-left-radius: 8px;
    background-color: var(--info-bg);
}
